import http from 'apis/config/http-service';
import { useCallback } from 'react';

const endpoint = 'ums/v1/cms/bnpl/restaurants';

type TOption = {
  value: number;
  label: string;
};

interface BnplRestaurantDto {
  id: number;
  nameEn: string;
}

export function useSearchBnplRestaurantsApi() {
  const loadOptions = useCallback((inputValue: string, callback: (options: TOption[]) => void) => {
    if (inputValue.length < 2) {
      callback([]);
      return;
    }

    http
      .get(endpoint, {
        params: {
          search: inputValue,
        },
      })
      .then((res) => {
        const options: TOption[] = (res?.data?.data || []).map((item: BnplRestaurantDto) => ({
          value: item.id,
          label: item.nameEn,
        }));
        callback(options);
      })
      .catch(() => callback([]));
  }, []);

  return { loadOptions };
}
